module.exports = __webpack_public_path__ + "media/ecom/arrowSteps-631d9e18.svg";